import { Grid, Pagination, Stack, useMediaQuery, useTheme } from "@mui/material";
import CoinsNews from "./CoinsNews";
import { useState } from "react";
import { format } from "date-fns";

interface CoinProps {
  newsData: any;
}

export default function CoinsNewsComponent(props: CoinProps) {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between(1000, 1300));
  const isMobile = useMediaQuery(theme.breakpoints.down(1000));
  let itemsPerPage = 5;

  if (isTablet) {
    itemsPerPage = 4;
  } else if (isMobile) {
    itemsPerPage = 3;
  }
  const [currentPage, setCurrentPage] = useState(1); //state for pagination
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, props.newsData?.length || 0);
  const pageCount = props.newsData ? Math.ceil(props.newsData.length / itemsPerPage) : 0;
  const handleChangePage = (event: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Stack
        padding={0}
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 2, sm: 2, md: 2 }}
        justifyContent={"flex-start"}>
        {props.newsData &&
          props.newsData.length > 0 &&
          props.newsData
            .slice(startIndex, endIndex)
            .map((news: any, index: number) => (
              <CoinsNews
                source={news.source}
                date={format(news.timestamp, "dd/MM/yyyy")}
                title={news.title}
                key={index}
                urlReference={news.link}
              />
            ))}
      </Stack>
      <Grid item alignItems={"center"} xs={12} paddingBottom={"30px"}>
        <Stack alignItems={"center"}>
          <Pagination
            count={pageCount}
            shape="rounded"
            page={currentPage}
            onChange={handleChangePage}
            variant="text"
            sx={{
              "& .MuiPaginationItem-page": {
                color: "black",
                border: "none",
                backgroundColor: "#FFFFFF",
              },
              "& .Mui-selected": {
                backgroundColor: "#FFFFFF",
                fontWeight: 600,
                border: "none",
              },
            }}
            showFirstButton
            showLastButton
          />
        </Stack>
      </Grid>
    </>
  );
}
